import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Menu, X } from "lucide-react";
import { business, navItems } from "../data/business";

export default function Header() {
    const [scrolled, setScrolled] = useState(false);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 40);
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <header
            className={`sticky top-0 z-40 transition-all duration-500 ${
                scrolled
                    ? "border-b border-line/70 bg-paper/90 backdrop-blur-md"
                    : "bg-transparent"
            }`}
        >
            <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-4 sm:px-8 lg:px-16">
                <a
                    href="#inicio"
                    data-testid="header-logo"
                    className="font-display text-lg font-semibold tracking-wide text-ink sm:text-2xl"
                >
                    STUDIO DANIELLY SOUSA
                </a>

                <nav className="hidden items-center gap-7 xl:flex">
                    {navItems.map((item) => (
                        <a
                            key={item.href}
                            href={item.href}
                            className="font-mono text-[10px] uppercase tracking-[0.18em] text-ink-soft transition-colors duration-300 hover:text-ink"
                        >
                            {item.label}
                        </a>
                    ))}
                </nav>

                <div className="flex items-center gap-3">
                    <a
                        href={business.whatsapp}
                        data-testid="header-cta"
                        className="hidden bg-ink px-5 py-3 font-mono text-[10px] uppercase tracking-[0.2em] text-paper transition-colors duration-300 hover:bg-accent sm:inline-block"
                    >
                        Agendar horário
                    </a>
                    <button
                        data-testid="header-menu-toggle"
                        aria-label="Abrir menu"
                        onClick={() => setOpen(!open)}
                        className="flex h-10 w-10 items-center justify-center border border-ink/15 text-ink xl:hidden"
                    >
                        {open ? <X size={18} /> : <Menu size={18} />}
                    </button>
                </div>
            </div>

            <AnimatePresence>
                {open && (
                    <motion.nav
                        initial={{ opacity: 0, height: 0 }}
                        animate={{ opacity: 1, height: "auto" }}
                        exit={{ opacity: 0, height: 0 }}
                        transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
                        className="overflow-hidden border-t border-line bg-paper xl:hidden"
                    >
                        <div className="flex flex-col px-6 py-6">
                            {navItems.map((item) => (
                                <a
                                    key={item.href}
                                    href={item.href}
                                    onClick={() => setOpen(false)}
                                    className="border-b border-line/60 py-4 font-display text-2xl text-ink"
                                >
                                    {item.label}
                                </a>
                            ))}
                            <a
                                href={business.whatsapp}
                                onClick={() => setOpen(false)}
                                className="mt-6 bg-ink px-6 py-4 text-center font-mono text-[11px] uppercase tracking-[0.2em] text-paper"
                            >
                                Falar com a equipe
                            </a>
                        </div>
                    </motion.nav>
                )}
            </AnimatePresence>
        </header>
    );
}
